import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY_COLOR } from '../constants';

type SectionTitleProps = {
  title: string,
  subtitle: string,
};

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  headBorder: {
    display: 'flex',
    alignItems: 'center',
    color: PRIMARY_COLOR,
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(14),
    '&::before, &::after': {
      content: '""',
      height: 3,
      flexGrow: 1,
      backgroundColor: PRIMARY_COLOR,
    },
    '&::before': {
      marginRight: '1rem',
    },
    '&::after': {
      marginLeft: '1rem',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '1.3rem',
    fontWeight: 'bold',
    margin: theme.spacing(1, 0, 2),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(24),
      margin: theme.spacing(1, 3, 2),
    },
  },
  underline: {
    height: 3,
    backgroundColor: PRIMARY_COLOR,
  },
}));

const SectionTitle = ({ title, subtitle }: SectionTitleProps) => {
  const classes = useStyles();
  return (
    <Typography variant="h2" className={classes.container}>
      <div>
        <div className={classes.headBorder}>{subtitle}</div>
        <Typography className={classes.title}>{title}</Typography>
        <div className={classes.underline} />
      </div>
    </Typography>
  );
};
export default SectionTitle;
